import simpleFetch, { ALL_SIMPLE_FETCH_ERRORS } from "../../../../utils/simpleFetch";
import { GET_CLIENT_V2, CLIENT_LIFECYCLE_BY_CLIENT_ID, GET_CLIENT_STATUS_TYPE } from "../../../utils/data/models";
import { toast } from "react-toastify";
import { TRANSITIONING } from "../enums/clientLifecycleTransitionType";
import React from "react/lib/React"; /** Do not remove this import, it's used by the toast library. */
import { FormattedMessage } from "react-intl";

export const getClient = async (clientId) => {
    if (!clientId) {
        throw new Error("The route does not have a client id parameter.");
    }

    try {
        const endpoint = GET_CLIENT_V2.path.replace("{}", clientId);
        return await simpleFetch("GET", endpoint, {});
    }
    catch (e) {
        /** If a promise error for unauthorized is thrown (403) by simpleFetch, we return false. If not, we throw the error. */
        if (e.status === 403) {
            return false;
        }
        throw e;
    }
};

export const checkClientBillingPeriodType = async (clientId, expectedBillingPeriodType) => {
    if (!clientId) {
        throw new Error("The route does not have a client id parameter.");
    }

    try {
        const res = await getClient(clientId);
        return res.clientBillingPeriodType === expectedBillingPeriodType;
    }
    catch (e) {
        /** If a promise error for unauthorized is thrown (403) by simpleFetch, we return false. If not, we throw the error. */
        if (e.status === 403) {
            return false;
        }
        throw e;
    }
};

export const getClientStatusType = async (clientId) => {

    if (!clientId) {
        throw new Error("The route does not have a client id parameter.");
    }

    try {
        const endpoint = GET_CLIENT_STATUS_TYPE.path.replace("{}", clientId);
        const res = await simpleFetch("GET", endpoint, {});
        return res.clientStatusType;
    }
    catch (e) {
        /** If a promise error for unauthorized is thrown (403) by simpleFetch, we return false. If not, we throw the error. */
        if (e.status === 403) {
            return false;
        }
        throw e;
    }
};
export const isClientInTransition = (clientId) => {
    const query = {
        sortBy: ["createdAt:desc"]
    };
    const result = simpleFetch("get", CLIENT_LIFECYCLE_BY_CLIENT_ID.path.replace("{}", clientId), { query }).then((res) => {
        return res && res.length > 0 && res[0].hasOwnProperty("transitionState") && res[0]["transitionState"] == TRANSITIONING.value;
    }).catch((error) => {
        if (error.status >= 500)
            toast(<FormattedMessage id="validation.customMessages.serverErrors.generic" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        return false;
    });
    return result;
};


export const isSimpleFetchToast = (data) => {
    return data.payload && data.payload.error && data.payload.error.data
        && data.payload.error.data.message && ALL_SIMPLE_FETCH_ERRORS.includes(data.payload.error.data.message.errorCode);
};


// WEBPACK FOOTER //
// ./src/components/common/RouteValidators/ClientValidationHelper.js